import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import "autotrack/lib/plugins/event-tracker";
import "autotrack/lib/plugins/outbound-link-tracker";
import "autotrack/lib/plugins/url-change-tracker";
import "autotrack/lib/plugins/page-visibility-tracker";
class GoogleAnalyticsAutotrack extends PolymerElement {
    static get template() {
        return html ``;
    }
    static get is() {
        return "google-analytics-autotrack";
    }
    static get properties() {
        return {
            name: { type: String, observer: "_nameChanged" },
            key: { type: String, observer: "_keyChanged" },
            created: { type: Boolean },
        };
    }
    ready(...args) {
        super.ready();
        // Google code: Disable linting
        /* eslint-disable no-undef, func-names */
        window.ga =
            window.ga ||
                function () {
                    (ga.q = ga.q || []).push(...args);
                };
        ga.l = +new Date();
        /* eslint-enable no-undef */
        if (this.$.key) {
            this.createTracker(this.$.name, this.$.key);
        }
    }
    createTracker(name, key) {
        window.ga("create", key, "auto", name);
        const reqText = name ? `${name}.require` : "require";
        // Replace the following lines with the plugins you want to use.
        window.ga(reqText, "eventTracker");
        window.ga(reqText, "outboundLinkTracker");
        window.ga(reqText, "urlChangeTracker");
        window.ga(reqText, "pageVisibilityTracker");
        window.ga("send", "pageview", name);
        this.$.created = true;
    }
    removeTracker(name) {
        if (name) {
            window.ga(`${name}.remove`);
        }
        else {
            window.ga("remove");
        }
        this.$.created = false;
    }
    _nameChanged(newName, oldName) {
        if (this.$.created) {
            this.removeTracker(oldName);
        }
        if (this.$.key) {
            this.createTracker(newName, this.$.key);
        }
    }
    _keyChanged(newKey) {
        if (!this.$) {
            return;
        }
        if (this.$.created) {
            this.removeTracker(this.$.name);
        }
        if (newKey) {
            this.createTracker(this.$.name, newKey);
        }
    }
}
customElements.define(GoogleAnalyticsAutotrack.is, GoogleAnalyticsAutotrack);
//# sourceMappingURL=google-analytics-autotrack.js.map